import React from 'react';
import Chart from 'react-apexcharts';
import { Category } from '../../types/Lessons';

const RadarChart = (props: { series: Category[], compare?: Category[] }) => {

  const filteredSeries = props.series.filter(category => category.causes > 0);
  const filteredCompare = props.compare?.filter(category => category.causes > 0) ?? [];
  const useFiltered = filteredSeries.length > 0 || filteredCompare.length > 0;
  const combined = [...new Set([...(useFiltered ? filteredSeries : props.series).map(category => category.name), ...(useFiltered ? filteredCompare : props.compare ?? []).map(category => category.name)])];

  const series = [{
    name: 'Causes',
    data: combined.map(categoryName => (props.compare ?? []).find(category => category.name === categoryName)?.causes || 0)
  },{
    name: 'Causes',
    data: combined.map(categoryName => props.series.find(category => category.name === categoryName)?.causes || 0)
  }];

  const options = {
    chart: {
      type: 'radar',
      toolbar: { show: false },
      offsetX: 0,
      offsetY: -20,
      parentHeightOffset: 0
    },
    plotOptions: {
      radar: {
        size: 120,
        polygons: {
          strokeColors: 'var(--color-greyDark)',
          connectorColors: 'var(--color-greyDark)',
        }
      },
    },
    xaxis: {
      categories: combined.map(category => {
        return category.includes('/') ? category.split('/')[0].trim() : category.trim();
      }),
      labels: {
        show: true,
        style: {
          colors: combined.map(() => 'var(--text-primary)'),
          fontSize: 10,
          fontFamily: 'var(--header-font)'
        }
      },
      axisTicks: { show: false },
      axisBorder: { show: false }
    },
    yaxis: {
      show: false
    },
    grid: {
      show: false
    },
    stroke: {
      width: 2.5,
      colors: ['var(--color-greyDark)', 'var(--color-purple)']
    },
    colors: ['var(--color-greyDark)', 'var(--color-purple)'],
    fill: {
      type: 'gradient',
      gradient: {
        type: 'vertical',
        gradientToColors: ['var(--color-purpleLight'],
        inverseColors: false,
        opacityFrom: 0.6,
        opacityTo: 0,
        stops: [0, 100]
      }
    },
    markers: {
      size: 5,
      colors: ['var(--color-greyDark)', 'var(--color-purple)'],
      strokeColors: 'white',
      strokeWidth: 1.5
    },
    legend: {
      show: false
    },
  };

  return <Chart options={options} series={series} type="radar" height={350} />
};

export default RadarChart;